var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicCop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.61111 1.44444H9.24083C10.0461 1.44444 10.3379 1.52822 10.6318 1.68567C10.9258 1.84311 11.1569 2.07422 11.3143 2.36817C11.4718 2.66211 11.5556 2.95389 11.5556 3.75917V9.38889C11.5556 9.58043 11.6316 9.76413 11.7671 9.89958C11.9025 10.035 12.0862 10.1111 12.2778 10.1111C12.4693 10.1111 12.653 10.035 12.7885 9.89958C12.9239 9.76413 13 9.58043 13 9.38889V3.70356C13 2.41583 12.8657 1.94856 12.6143 1.47767C12.368 1.01242 11.9876 0.631951 11.5223 0.385667C11.0514 0.134333 10.5842 0 9.29644 0H3.61111C3.41957 0 3.23587 0.076091 3.10042 0.211534C2.96498 0.346977 2.88889 0.530677 2.88889 0.722222C2.88889 0.913767 2.96498 1.09747 3.10042 1.23291C3.23587 1.36835 3.41957 1.44444 3.61111 1.44444ZM9.18739 3.13011C8.89344 2.97267 8.60167 2.88889 7.79639 2.88889H2.31472C1.50944 2.88889 1.21767 2.97267 0.923722 3.13011C0.632944 3.28404 0.395155 3.52183 0.241222 3.81261C0.0837779 4.10656 0 4.39833 0 5.20361V10.6853C0 11.4898 0.0837779 11.7823 0.241222 12.0763C0.398667 12.3702 0.629778 12.6013 0.923722 12.7588C1.21767 12.9162 1.50944 13 2.31472 13H7.79639C8.60094 13 8.89344 12.9162 9.18739 12.7588C9.48133 12.6013 9.71244 12.3702 9.86989 12.0763C10.0273 11.7823 10.1111 11.4906 10.1111 10.6853V5.20361C10.1111 4.39833 10.0273 4.10656 9.86989 3.81261C9.71596 3.52183 9.47817 3.28404 9.18739 3.13011Z",
    fill: "#00E194"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicCop);
export default __webpack_public_path__ + "static/media/tic_cop.b952c8349f3694af0e7fce1ffdcd2c19.svg";
export { ForwardRef as ReactComponent };